'use client';

import type { GeneratorMetadata } from '@/lib/types/generator';
import { cn } from '@/lib/utils';
import { Alibaba, ElevenLabs, Grok, NanoBanana, Qwen, Runway, Sora } from '@lobehub/icons';

const ICON_MAP: Record<string, any> = {
  Alibaba,
  ElevenLabs,
  Grok,
  NanoBanana,
  TongyiMAI: Qwen,
  Runway,
  Sora,
};

interface GeneratorIconProps {
  generator?: GeneratorMetadata;
  className?: string;
  size?: number;
}

export function GeneratorIcon({ generator, className, size = 64 }: GeneratorIconProps) {
  const IconComponent = generator?.iconName ? ICON_MAP[generator.iconName] : null;

  if (!IconComponent) return null;

  return (
    <div
      className={cn(
        'generator-icon-wrapper flex items-center justify-center overflow-visible',
        className
      )}
    >
      <div className="relative flex items-center justify-center">
        <IconComponent
          size={size}
          style={{
            color: '#94a3b8',
          }}
        />
        {/* SVG Gradient definition since lobe-icons are SVG-based */}
        <svg width="0" height="0" className="absolute">
          <defs>
            <linearGradient id="silver-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#e2e8f0" />
              <stop offset="100%" stopColor="#94a3b8" />
            </linearGradient>
          </defs>
        </svg>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          .generator-icon-wrapper svg path {
            fill: url(#silver-gradient) !important;
          }
        `,
          }}
        />
      </div>
    </div>
  );
}
